import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./context/AuthContext";
import Login from "./components/layouts/Login";
import SocialSignUp from "./components/layouts/SocialSignUp";
import { Amplify } from "aws-amplify";
import "./styles/main.scss";

import awsConfig from "./config/awsConfig";
import { fetchAuthSession } from "aws-amplify/auth";
import Verify from "./components/layouts/Verify";
import Register from "./components/layouts/Register";
import Navigation from "./components/layouts/Navigation";
import LogoutLink from "./components/layouts/LogoutLink";
import Profile from "./components/layouts/Profile";
import ForgotPassword from "./components/layouts/ForgotPassword";

Amplify.configure(awsConfig);

(window as any).getAuthStatus = async () => {
  try {
    const session = await fetchAuthSession();
    return {
      isAuthenticated: !!session.tokens,
      tokens: session.tokens
        ? {
            accessToken: session.tokens.accessToken?.toString(),
            idToken: session.tokens.idToken?.toString(),
          }
        : null,
    };
  } catch (error) {
    return {
      isAuthenticated: false,
      tokens: null,
    };
  }
};

const componentMap = {
  "login-target": Login,
  "social-sign": SocialSignUp,
  verify: Verify,
  register: Register,
  "username-nav": Navigation,
  "logout-comp": LogoutLink,
  profile: Profile,
  "forgot-password": ForgotPassword,
};

document.addEventListener("DOMContentLoaded", () => {
  Object.entries(componentMap).forEach(([targetId, Component]) => {
    const container = document.getElementById(targetId);

    if (container) {
      console.log(`[Webflow-Block] Mounting ${targetId}...`);
      const root = ReactDOM.createRoot(container);

      root.render(
        React.createElement(AuthProvider, null, React.createElement(Component))
      );
    }
  });
});
